module.exports = __webpack_public_path__ + "img/w3_button_reload_grey.a2e4b2ab.png";